/**
 * Defines a model of MyFitnessPal User Authorization
 */
import Backbone from 'backbone';
import { isReadonlyMode } from 'system/SystemUtil';

const MyFitnessPalAuthorization = Backbone.Model.extend({
    idAttribute: 'linkStatus',

    backend: 'gcapi',

    url: function() {
        let url = '/myfitnesspal-service/userAuthorization';

        if (isReadonlyMode()) {
            url = '/myfitnesspal-service/accountInformation';
        }

        return url;
    }
});

export default MyFitnessPalAuthorization;
